import queryString from "query-string";
import useSWR from "swr";
import oauthConfig from "../../../oauth.config";
import api_config from "../../../settings/api.config";
import { fetcher } from "../handler";
const hostname = api_config.hostname;

// @TODO: Update API documentation with new functions from this file

export const useBrowseSitepages = (values = {}) => {
  const qs = queryString.stringify(values, {
    skipNull: true,
    skipEmptyString: true,
    sort: (a, b) => a.localeCompare(b), // deterministic key
  });

  const url = `${hostname}/sitepages/browse${qs ? `?${qs}` : ""}`;

  return useSWR(
    [
      url, // <-- key changes when `values` (e.g., orderby) changes
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          oauth_consumer_key: oauthConfig.oauth_consumer_key,
          oauth_consumer_secret: oauthConfig.oauth_consumer_secret,
        },
      },
    ],
    fetcher,
    {
      keepPreviousData: true,
      revalidateOnFocus: false,
      dedupingInterval: 0,
    }
  );
};

export const useGetSitePage = (page_id, values) => {
  return useSWR(
    [
      hostname + "/sitepage/view/" + page_id,
      {
        method: "GET",
        body: queryString.stringify(values),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          oauth_consumer_key: oauthConfig.oauth_consumer_key,
          oauth_consumer_secret: oauthConfig.oauth_consumer_secret,
        },
      },
    ],
    fetcher,
  );
};

export const useGetSitePageAlbums = (page_id, values) => {
  return useSWR(
    [
      hostname + "/sitepage/photos/index/" + page_id,
      {
        method: "GET",
        body: queryString.stringify(values),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          oauth_consumer_key: oauthConfig.oauth_consumer_key,
          oauth_consumer_secret: oauthConfig.oauth_consumer_secret,
        },
      },
    ],
    fetcher,
  );
};

export const useGetSitePageAlbumPhotos = (page_id, album_id, values) => {
  return useSWR(
    [
      hostname + `/sitepage/photos/viewalbum/${page_id}/${album_id}`,
      {
        method: "GET",
        body: queryString.stringify(values),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          oauth_consumer_key: oauthConfig.oauth_consumer_key,
          oauth_consumer_secret: oauthConfig.oauth_consumer_secret,
        },
      },
    ],
    fetcher,
  );
};

export const useGetSitePageReviews = (page_id, values) => {
  return useSWR(
    [
      hostname + `/sitepage/reviews/browse/${page_id}`,
      {
        method: "GET",
        body: queryString.stringify(values),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          oauth_consumer_key: oauthConfig.oauth_consumer_key,
          oauth_consumer_secret: oauthConfig.oauth_consumer_secret,
        },
      },
    ],
    fetcher,
  );
};

export const useGetSitePageManaged = (values) => {
  return useSWR(
    [
      hostname + "/sitepages/manage",
      {
        method: "GET",
        body: queryString.stringify(values),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          oauth_consumer_key: oauthConfig.oauth_consumer_key,
          oauth_consumer_secret: oauthConfig.oauth_consumer_secret,
        },
      },
    ],
    fetcher,
  );
};

export const useGetEditSitePageForm = (page_id, values) => {
  return useSWR(
    [
      hostname + "/sitepage/edit/" + page_id,
      {
        method: "GET",
        body: queryString.stringify(values),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          oauth_consumer_key: oauthConfig.oauth_consumer_key,
          oauth_consumer_secret: oauthConfig.oauth_consumer_secret,
        },
      },
    ],
    fetcher,
  );
};

export const postEditSitePage = (page_id, values) => {
  return fetcher(
    [
      hostname + `/sitepage/edit/${page_id}`,
      {
        method: "POST",
        body: values,
        headers: {
          Accept: "application/json",
        },
      },
    ],
    true,
  );
};

// Get Sitepage Statistics
export const useGetSitePageStatistics = (page_id, values) => {
  return useSWR(
    [
      hostname + `/sitepages/statistics`,
      {
        method: "GET",
        body: queryString.stringify(values),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          oauth_consumer_key: oauthConfig.oauth_consumer_key,
          oauth_consumer_secret: oauthConfig.oauth_consumer_secret,
        },
      },
    ],
    fetcher,
  );
};

//Get Sitepage Manage Admins
export const useGetSitePageManageAdmins = (page_id, values) => {
  const qs = values ? `?${queryString.stringify(values)}` : "";
  const url = `${hostname}/sitepage/manageadmins/${page_id}${qs}`;
  return useSWR([url, { method: "GET", headers: {
    Accept: "application/json",
    oauth_consumer_key: oauthConfig.oauth_consumer_key,
    oauth_consumer_secret: oauthConfig.oauth_consumer_secret,
  }}], fetcher);
};

export const useGetSitePageCreateForm = () => {
  return useSWR(
    [
      hostname + "/sitepages/create", 
      {
        method: "GET", 
        body: queryString.stringify({}),
        headers: {
          "Content-Type": "application/json", 
          Accept: "application/json", 
          oauth_consumer_key: oauthConfig.oauth_consumer_key, 
          oauth_consumer_secret: oauthConfig.oauth_consumer_secret, 
        }
      }
    ],
    fetcher
  ); 
}

export const useGetSitePagePackages = () => {
  return useSWR(
    [
      hostname + "/sitepages/packages", 
      {
        method: "GET", 
        body: queryString.stringify({}), 
        headers: {
          "Content-Type": "application/json", 
          Accept: "application/json", 
          oauth_consumer_key: oauthConfig.oauth_consumer_key, 
          oauth_consumer_secret: oauthConfig.oauth_consumer_secret
        }
      }
    ],
    fetcher
  )
}

export const useGetPendingRequests = (page_id) => {
  return useSWR(
    [
      hostname + `/sitepage/pending-requests/${page_id}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          oauth_consumer_key: oauthConfig.oauth_consumer_key,
          oauth_consumer_secret: oauthConfig.oauth_consumer_secret,
        },
      },
    ],
    fetcher
  );
};

export const useGetSitePageNotificationSettings = (page_id) => {
  return useSWR(
    [
      hostname + `/sitepage/notification-settings/${page_id}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          oauth_consumer_key: oauthConfig.oauth_consumer_key,
          oauth_consumer_secret: oauthConfig.oauth_consumer_secret,
        },
      },
    ],
    fetcher
  );
};


export const postApprovePendingRequest = ({ pageId, memberId }) => {
  const qs = memberId ? `?${queryString.stringify({member_id: memberId})}` : "";
  return fetcher(
    [
      hostname + `/sitepage/approve-pending/${pageId}${qs}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Accept: "application/json",
          oauth_consumer_key: oauthConfig.oauth_consumer_key,
          oauth_consumer_secret: oauthConfig.oauth_consumer_secret,
        }
      },
    ],
    false,
    true
  );
};

export const postRejectPendingRequest = ({ pageId, memberId }) => {
  const qs = memberId ? `?${queryString.stringify({member_id: memberId})}` : "";
  return fetcher(
    [
      hostname + `/sitepage/reject-pending/${pageId}${qs}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Accept: "application/json",
          oauth_consumer_key: oauthConfig.oauth_consumer_key,
          oauth_consumer_secret: oauthConfig.oauth_consumer_secret,
        }
      },
    ],
    false,
    true
  );
};

export const postSitePageAcceptInvite = ({ pageId }) => {
  return fetcher(
    [
      hostname + "/sitepage/accept-invite/"+pageId,
      {
        method: "POST",
        body: queryString.stringify({ page_id: pageId }),
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Accept: "application/json",
          oauth_consumer_key: oauthConfig.oauth_consumer_key,
          oauth_consumer_secret: oauthConfig.oauth_consumer_secret,
        },
      },
    ],
    false,
    true
  );
};

export const postSitePageRejectInvite = ({ pageId }) => {
  return fetcher(
    [
      hostname + "/sitepage/reject-invite/"+pageId,
      {
        method: "POST",
        body: queryString.stringify({ page_id: pageId }),
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Accept: "application/json",
          oauth_consumer_key: oauthConfig.oauth_consumer_key,
          oauth_consumer_secret: oauthConfig.oauth_consumer_secret,
        },
      },
    ],
    false,
    true
  );
};

export const postCreatePage = (values) => {
  return fetcher(
    [
      hostname + "/sitepages/create",
      {
        method: "POST",
        body: values,
        headers: {
          Accept: "application/json",
        },
      },
    ],
    true,
  );
};

export const postDeletePage = (id) => {
  return fetcher(
    [
      hostname + `/sitepage/delete/${id}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          oauth_consumer_key: oauthConfig.oauth_consumer_key,
          oauth_consumer_secret: oauthConfig.oauth_consumer_secret,
        },
      },
    ],
    false,
    true
  );
};

export const useGetSitePageInviteMembers = (page_id) => {
  return useSWR(
    page_id
      ? [
          hostname + "/sitepage/invite-members/" + page_id,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              oauth_consumer_key: oauthConfig.oauth_consumer_key,
              oauth_consumer_secret: oauthConfig.oauth_consumer_secret,
            },
          },
        ]
      : null,
    fetcher
  );
};

export const postSitePageInviteMembers = (page_id, values) => {
  const qs = values ? `?${queryString.stringify(values)}` : "";
  return fetcher(
    [
      hostname + `/sitepage/invite-members/${page_id}${qs}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Accept: "application/json",
          oauth_consumer_key: oauthConfig.oauth_consumer_key,
          oauth_consumer_secret: oauthConfig.oauth_consumer_secret,
        },
      },
    ],
    false,
    true
  );
};

export const postTellAFriend = (id, values) => {
  return fetcher(
    [
      hostname + `/sitepage/tellafriend/${id}`,
      {
        method: "POST",
        body: values,
        headers: {
          Accept: "application/json",
        },
      },
    ],
    true,
  );
};

export const postDeletePageAlbumPhoto = (photo_id, album_id, page_id) => {
  return fetcher(
    [
      hostname + `/sitepage/photos/deletephoto/${page_id}/${album_id}/${photo_id}`,
      {
        method: "DELETE",
        headers: {
          Accept: "application/json",
          oauth_consumer_key: oauthConfig.oauth_consumer_key,
          oauth_consumer_secret: oauthConfig.oauth_consumer_secret,
        },
      },
    ],
    false, true
  )
}
export const postFollowPage = (id) => {
  return fetcher(
    [
      hostname + `/sitepage/follow/${id}`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          oauth_consumer_key: oauthConfig.oauth_consumer_key,
          oauth_consumer_secret: oauthConfig.oauth_consumer_secret,
        },
      },
    ],
    false, true
  );
}

export const postJoinPage = (id) => {
  return fetcher(
    [
      hostname + `/sitepage/join/${id}`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          oauth_consumer_key: oauthConfig.oauth_consumer_key,
          oauth_consumer_secret: oauthConfig.oauth_consumer_secret,
        },
      },
    ],
    false, true
  );
}

export const postLeavePage = (id) => {
  return fetcher(
    [
      hostname + `/sitepage/leave/${id}`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          oauth_consumer_key: oauthConfig.oauth_consumer_key,
          oauth_consumer_secret: oauthConfig.oauth_consumer_secret,
        },
      },
    ],
    false, true
  )
}

export const postChangeRole = (page_id, values) => {
  const qs = values ? `?${queryString.stringify(values)}` : "";
  return fetcher(
    [
      hostname + `/sitepage/changerole/${page_id}${qs}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Accept: "application/json",
          oauth_consumer_key: oauthConfig.oauth_consumer_key,
          oauth_consumer_secret: oauthConfig.oauth_consumer_secret,
        },
      },
    ],
    false,
    true
  )
}

export const postChangePhoto = (page_id, values) => {
  return fetcher(
    [
      hostname + `/sitepage/photo/${page_id}`,
      {
        method: "POST",
        body: values,
        headers: {
          Accept: "application/json",
        },
      },
    ],
    true,
  );
};

export const postSitePageNotificationSettings = (page_id, values) => {
  const qs = values ? `?${queryString.stringify(values)}` : "";
  return fetcher(
    [
      hostname + `/sitepage/notification-settings/${page_id}${qs}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Accept: "application/json",
          oauth_consumer_key: oauthConfig.oauth_consumer_key,
          oauth_consumer_secret: oauthConfig.oauth_consumer_secret,
        },
      },
    ],
    false,
    true
  )
}
